export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const HEAD_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceHead: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    fontanellesHead: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsHeadSections =
  keyof typeof HEAD_FORM_INITIAL_VALUES.sections;
